module.exports = ".cl{\n    background-color: cadetblue;\n}"